import { EstimateStatus } from '@/types/estimates/EstimateStatus';
import { Translator } from '@/types/translator.type';

export const getEstimateStatusLabel = (
  status: EstimateStatus,
  isReceiver = false,
  t: Translator,
) => {
  switch (status) {
    case EstimateStatus.ESTIMATE:
      return isReceiver
        ? t('estimates.statusType.estimate_receiver')
        : t('estimates.statusType.estimate_distributor');
    case EstimateStatus.PENDING:
      return t('estimates.statusType.pending');
    case EstimateStatus.RESERVED:
      return t('estimates.statusType.reserved');
    case EstimateStatus.REFUSED:
      return t('estimates.statusType.refused');
  }
};
